export default __webpack_public_path__ + "746a2147ffc1cf61f234fb084fa4c8c6.svg";